var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomePc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_23649)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "#E1DEF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_23649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_23649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6668 22.6668L20.0002 20.0002H13.3335C12.9668 20.0002 12.6529 19.8696 12.3918 19.6085C12.1307 19.3474 12.0002 19.0335 12.0002 18.6668V18.0002H19.3335C19.7002 18.0002 20.0141 17.8696 20.2752 17.6085C20.5363 17.3474 20.6668 17.0335 20.6668 16.6668V12.0002H21.3335C21.7002 12.0002 22.0141 12.1307 22.2752 12.3918C22.5363 12.6529 22.6668 12.9668 22.6668 13.3335V22.6668ZM10.6668 16.1168L11.4502 15.3335H18.0002V10.6668H10.6668V16.1168ZM9.3335 19.3335V10.6668C9.3335 10.3002 9.46405 9.98627 9.72516 9.72516C9.98627 9.46405 10.3002 9.3335 10.6668 9.3335H18.0002C18.3668 9.3335 18.6807 9.46405 18.9418 9.72516C19.2029 9.98627 19.3335 10.3002 19.3335 10.6668V15.3335C19.3335 15.7002 19.2029 16.0141 18.9418 16.2752C18.6807 16.5363 18.3668 16.6668 18.0002 16.6668H12.0002L9.3335 19.3335Z",
    fill: "#62648F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_23649"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePc2);
export default __webpack_public_path__ + "static/media/welcome_pc_2.9cd8f5efd611b9b9f3db41537b7d66e4.svg";
export { ForwardRef as ReactComponent };